

































































































import { Component } from 'vue-property-decorator';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import InstitutionAccountState from '@/components/Accounts/InstitutionAccounts/InstitutionAccountState.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'InstitutionalAccountDetails', components: { InstitutionAccountState } })
export default class extends SaascadaVue {

    get account() {
        return InstitutionAccountModule.institutionalAccount;
    }

    get iban() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].localisation.iban;
        }
        return "";
    }

    get bic() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].localisation.bic;
        }
        return "";
    }

    get sortCode() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].localisation.sortCode;
        }
        return "";
    }

    get accountNumber() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].localisation.accountNumber;
        }
        return "";
    }

}
